import React from 'react';
import styles from './SectionLabel.module.css';

function SectionLabel({ label }) {
  return <span className={styles.label}>/ {label}</span>;
}

export default SectionLabel;
